<template>
    <svg width="45" height="41" viewBox="0 0 45 41" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M26.4423 36.1681C27.8665 37.2522 29.5533 37.9244 31.3236 38.1134C33.0938 38.3024 34.8815 38.0012 36.4967 37.2417C38.1119 36.4822 39.4943 35.2927 40.4972 33.7997C41.5 32.3066 42.0859 30.5657 42.1925 28.7618C42.2992 26.9579 41.9226 25.1583 41.1028 23.5542C40.2831 21.9501 39.0507 20.6013 37.5366 19.6512C36.0224 18.701 34.2831 18.1848 32.5033 18.1575C30.7235 18.1302 28.9696 18.5928 27.4279 19.4962L22.5 12.1538"
            stroke="#FD6144"
            stroke-width="3"
        />
        <path
            d="M32.3558 12.1536C32.3555 10.3973 31.8998 8.67197 31.0346 7.15107C30.1694 5.63017 28.9251 4.36727 27.4268 3.4893C25.9284 2.61133 24.2289 2.14922 22.4989 2.14941C20.7689 2.14961 19.0695 2.61209 17.5714 3.49039C16.0732 4.3687 14.8292 5.63187 13.9643 7.15296C13.0994 8.67405 12.6442 10.3995 12.6442 12.1558C12.6443 13.9121 13.0997 15.6375 13.9648 17.1585C14.8298 18.6795 16.0739 19.9426 17.5721 20.8208L12.6442 28.1631"
            stroke="#5021D1"
            stroke-width="3"
        />
        <path
            d="M5.6072 21.1592C4.47523 22.3311 3.64463 23.7678 3.18861 25.3426C2.7326 26.9173 2.66517 28.5818 2.99229 30.1893C3.3194 31.7967 4.03101 33.2978 5.06438 34.5602C6.09775 35.8225 7.42114 36.8074 8.91789 37.428C10.4146 38.0486 12.0388 38.2858 13.6472 38.1188C15.2555 37.9518 16.7988 37.3856 18.1407 36.4702C19.4827 35.5548 20.5823 34.3183 21.3425 32.8696C22.1027 31.421 22.5002 29.8048 22.5 28.1633H32.3558"
            stroke="#FD6144"
            stroke-width="3"
        />
        <path
            d="M12.6442 32.1654C14.8215 32.1654 16.5865 30.3735 16.5865 28.163C16.5865 25.9526 14.8215 24.1606 12.6442 24.1606C10.4669 24.1606 8.7019 25.9526 8.7019 28.163C8.7019 30.3735 10.4669 32.1654 12.6442 32.1654Z"
            fill="#5021D1"
        />
        <path
            d="M32.3558 32.1654C34.533 32.1654 36.2981 30.3735 36.2981 28.163C36.2981 25.9526 34.533 24.1606 32.3558 24.1606C30.1785 24.1606 28.4135 25.9526 28.4135 28.163C28.4135 30.3735 30.1785 32.1654 32.3558 32.1654Z"
            fill="#FD6144"
        />
        <path
            d="M22.5 16.1561C24.6773 16.1561 26.4423 14.3642 26.4423 12.1537C26.4423 9.94329 24.6773 8.15137 22.5 8.15137C20.3227 8.15137 18.5577 9.94329 18.5577 12.1537C18.5577 14.3642 20.3227 16.1561 22.5 16.1561Z"
            fill="#FD6144"
        />
    </svg>
</template>
<script>
export default {
    name: "WebhookIntegration",
};
</script>
